import { formatDate } from "hooks";
import React from "react";
import { useFormatPrice } from "hooks";

const Details = ({ values }) => {
  const formatPrice = useFormatPrice();

  return (
    <div className="grid grid-cols-2 gap-3 p-[10px]">
      <div className="flex flex-col">
        <div className="flex gap-2 font-medium">
          <span>Id: {values.id} </span> |
          <span className="text-[14px] uppercase">{values.printTypeName}</span>
        </div>

        <span className="text-[12px]">{formatDate(values.createDate)}</span>
      </div>
      <div className="flex flex-col text-[14px] uppercase">
        <div className="flex gap-1">
          <span>Total Item : </span>
          <span className="font-bold">{values.totalItem}</span>
        </div>
        <div className="flex gap-1">
          <span>Total Label : </span>
          <span className="font-bold">{values.totalLabel}</span>
        </div>
      </div>

      <div className="flex flex-col text-[14px] uppercase">
        <div className="flex gap-1">
          <span>Print User : </span>
          <span className="font-bold">
            {values.user &&
              values.user?.firstName + " " + values.user?.lastName}
          </span>
        </div>
        <div className="flex gap-1">
          <span>Outlet : </span>
          <span className="font-bold">{values.outlet?.outletName}</span>
        </div>
      </div>

      <div className="text-[13px] uppercase">
        <div className="flex gap-1">
          <span>Outlet Name :</span>
          <span className="font-bold">{values.showOutlet.toString()}</span>
        </div>
        <div className="flex gap-1">
          <span>Product Title :</span>
          <span className="font-bold">{values.showProdTitle.toString()}</span>
        </div>
      </div>
      <div className="text-[13px] uppercase">
        <div className="flex gap-1">
          <span>Sku Code :</span>
          <span className="font-bold">{values.showSku.toString()}</span>
        </div>

        <div className="flex gap-1">
          <span>Retail Price :</span>
          <span className="font-bold">{formatPrice(values.showRtlPrice)}</span>
        </div>
      </div>
    </div>
  );
};

export default Details;
